import axios from "axios";

import { BASE_URL } from "../../../services/configUrls";

// Get all Google Meet links for staff
export const getAllGoogleMeetForStaff = async () => {
  try {
    let config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${BASE_URL}/staffmetting/getAllGoogleMeetForStaff`,
      headers: {}
    };

    const response = await axios.request(config);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error fetching staff Google Meet links:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message || 'Failed to fetch data'
    };
  }
};

// Update Google Meet link for staff
export const updateGoogleMeetForStaff = async (email, googleMeetLink) => {
  try {
    let data = JSON.stringify({
      "email": email,
      "google_meet_link": googleMeetLink
    });

    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `${BASE_URL}/staffmetting/updateGoogleMeetforstaff`,
      headers: {
        'Content-Type': 'application/json'
      },
      data: data
    };

    const response = await axios.request(config);
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error updating Google Meet link:', error);
    return {
      success: false,
      error: error.response?.data?.message || error.message || 'Failed to update link'
    };
  }
};
